import status from "http-status";
import moment from "moment";
import { createCrudActions } from "../utils/crudGenerator";
import { fetchAccounts } from "./accountsActions";

const formatSpents = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.name}`,
    value: item._id,
    date: item.date && moment(item.date),
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

const crudActions = createCrudActions("SPENT", "Gasto", formatSpents);

export const { fetch: fetchSpents } = crudActions;

const withAccountsRefresh =
  (actionCreator) =>
  (...args) =>
  async (dispatch) => {
    const response = await dispatch(actionCreator(...args));
    if (status[`${response}_CLASS`] === status.classes.SUCCESSFUL) {
      dispatch(fetchAccounts());
    }
    return response;
  };

export const createSpent = withAccountsRefresh(crudActions.create);
export const updateSpent = withAccountsRefresh(crudActions.update);
export const deleteSpents = withAccountsRefresh(crudActions.delete);
